import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter, ChangeDetectorRef, SimpleChanges, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { distinctUntilChanged, filter, take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as OT from '@opentok/client';

import { Message, FileData, FileError, MessageRawData } from '../../../../models';
import { ActivatedRoute } from '@angular/router';
import { ApiChatMessagesService } from '../../../../api/apiChatMessages/api-chat-messages.service';
import { IGetStoredChatMessageResponseItem, IPostStoredChatMessageRequest, IPostStoredChatMessageResponseItem } from '../../../../api/apiChatMessages/apiChatMessages.models';
import { EVENTS_CONSTANTS } from '../../../../constants/events.constants';
import { CheckFocusService } from '../../../../services/check-focus/check-focus.service';
import { VideoconferenceMainModalService } from '../../services/videoconference-main-modal.service';
import { VIDEOCONFERENCE_CONSTANTS } from '../../../../constants/videoconference.constants';
import { EnvironmentService } from '../../../../services/enviroment/environment.service';
import { UtilsService } from '../../../../services/utils/utils.service';
import { StateHandlerService } from '../../../../services/state-handler/state-handler.service';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass, NgStyle } from '@angular/common';


@Component({
  standalone: true,
  imports: [ReactiveFormsModule, TranslatePipe, NgClass, NgStyle],
  selector: 'sas-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit, AfterViewInit {
  @Input() session?: OT.Session;
  @Input() name!: string;
  @Input() participantsData: any;
  @Input() storedChatMessages?: IGetStoredChatMessageResponseItem[];
  @Output() hasMessages: EventEmitter<boolean> = new EventEmitter();
  @Output() toggleChat: EventEmitter<any> = new EventEmitter();
  @ViewChild('msgHistory') msgHistory?: ElementRef;
  @ViewChild('msgOwner') msgOwner?: ElementRef;
  public chatMessages: Array<Message> = [];
  public msgCounter = 0;
  public formChat?: FormGroup;
  public completeFile = '';
  public typesFile;
  public errorTypesText;
  public maxMBSizeFile;
  public showAlertSizeFile = false;
  public showAlertTypeFile = false;
  public iconNotification: boolean = false;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private signalEvents = EVENTS_CONSTANTS.SESSION_EVENTS.SIGNAL;
  private getMessageMap = {
    [this.signalEvents.MSG]: (message: Message, data: any) => this.buildTextMessage(message, data),
    [this.signalEvents.FILE_PDF_END]: (message: Message, data: any) => this.buildPDFMessage(message, data),
    [this.signalEvents.FILE_IMAGE_END]: (message: Message, data: any) => this.buildImgMessage(message, data),
  };

  public features;
  /**
   * Mostrar capa para bloquear entradas de chat y mostrar capa de subiendo archivo o seleccionando archivo.
   */
  loadingFile = false;
  selectionFile = false;
  /**
   * Habilita la funcionalidad de guardado en BBDD
   */
  enableDDBBStorage;
  /**
   * Variable que indica si es IOS de mobilidad
   */
  isIOsMobilityDevice = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly envConf: EnvironmentService,
    private readonly sanitizer: DomSanitizer,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly utilsService: UtilsService,
    private readonly checkFocusSrv: CheckFocusService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly apiChatMessagesService: ApiChatMessagesService,
    private readonly stateHandlerSvc: StateHandlerService,
    private readonly videoconferenceMainModalService: VideoconferenceMainModalService
  ) {
    this.enableDDBBStorage = this.envConf.data?.features?.enable_bbdd_storage;
    this.features = this.envConf.data.features;
    this.typesFile = this.envConf.data.chat.typesFile;
    this.errorTypesText = this.envConf.data.chat.errorTypesText;
    this.maxMBSizeFile = this.envConf.data.chat.maxSizeFile / 1000000;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.enableDDBBStorage && changes['storedChatMessages']) {
      //TODO: evolutivo reescritura mensajes guardados en bbdd
      this.setStoredMessasges();
    }
  }
  ngAfterViewInit(): void {
    this.isIOsMobilityDevice = this.utilsService.isIOsMobilityUAPArser();
  }
  setStoredMessasges() {
    if (this.storedChatMessages?.length){
      const message: IGetStoredChatMessageResponseItem = {...this.storedChatMessages[0]};
      this.storedChatMessages = this.storedChatMessages.slice(1);
      const text = message.message || message.fileName;
      const attendantId = this.activatedRoute.snapshot.queryParams[VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT];
      const dataMessage = {
        name: message.name,
        owner: attendantId === message.attendantId? 'mine' : 'theirs',
        text: ''
      }
      switch (true) {
        case (message.fileType !== undefined && message.fileType !== null):
          // dataMessage.text = message.fileName;
          if (message.fileType.includes('image')) {
            this.buildImgMessage(dataMessage, `${message.fileName}%%${message.dateMessage}`);
          } else {
            this.buildPDFMessage(dataMessage, `${message.fileName}%%${message.dateMessage}`);
          }
          break;
        default:
          dataMessage.text = message.message;
          this.buildTextMessage(dataMessage, message.message)
          break;
        }
        this.changeDetectorRef.detectChanges();
      }
  }


  ngOnInit() {
    this.formChat = this.formBuilder.group({
      textChat: ['', this.validChatMessage],
      file: '',
    });
    this.loadSignal();
    this.checkFocusSrv.initFocusListeners();
  }

  sanitizeUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  getColor(name: string) {
    const participants = this.participantsData;
    const messageOwner = participants.filter((participant:any) => participant.name === name);
    let color: string = messageOwner[0]?.color ? messageOwner[0].color : '#dc752d' ;

    if (messageOwner.length > 1) {
      messageOwner.forEach((participant: any) => {
        if (participant.id === 'publisher') {
          color = messageOwner[1].color;
        }
      });
    }

    return '2px solid ' + color;
  }

  checkExistOwners(messageOwner: Message) {
    return this.chatMessages.filter((message) => {
      return messageOwner.name === message.name;
    });
  }

  formatMessageWithColor(message: Message) {
    if (this.checkExistOwners(message)[0]) {
      message = {
        name: message.name,
        owner: message.owner,
        text: message.text,
        color: this.checkExistOwners(message)[0].color
      };
    } else {
      message = {
        name: message.name,
        owner: message.owner,
        text: message.text,
        color: this.getColor(message.name || '')
      };
    }
    return message;
  }

  countMessages(numMsg: boolean): void {
    this.hasMessages.emit(numMsg);
  }

  buildMessage(event: any) {
    const message = new Message();
    const messageData = this.getMessageData(event.data);
    message.name = messageData.name;
    message.owner = event.from.connectionId === this.session?.connection?.connectionId ? VIDEOCONFERENCE_CONSTANTS.CHAT.OWNER_MINE : VIDEOCONFERENCE_CONSTANTS.CHAT.OWNER_THEIRS;
    if (event.from.connectionId !== this.session?.connection?.connectionId) {
      console.log('Signal received from another client');
      this.iconNotification = true;
    }
    this.getMessageMap[event.type](message, messageData.data);
    this.completeFile = messageData.data.includes('%%')? messageData.data : '';
  }

  getChatFile(message: Message, download?: boolean){
    const attendantId = this.activatedRoute.snapshot.queryParams[VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT];
    this.apiChatMessagesService.getChatFile(attendantId, message.id as number).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (resp: any) => {
        const imageArrayBuffer = resp[0].file.split(',')[1];
        if ((message.type as string).includes('image') && !download){
            this.parseImg(message, imageArrayBuffer);
        } else {
          this.utilsService.openFile(imageArrayBuffer, (message.fileName as string), (message.type as string));
        }
        if (this.enableDDBBStorage && this.storedChatMessages?.length){
          this.setStoredMessasges();
        }
        this.changeDetectorRef.detectChanges();
      },
      (err) => console.log('error apiChatMessagesService.getChatFile(attendantId, message.id)', err)
    );
  }

  parseImg(message: Message, imageArrayBuffer?: string) {
    this.utilsService.datatoBlob$(imageArrayBuffer || (message.doc as string), message.type as string).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (blob: Blob) => {
        message.img = this.utilsService.blobToUrl(blob, message.fileName as string, message.type as string);
        message.urlBlob = message.img;
        this.chatMessages.push(message);
        this.changeDetectorRef.detectChanges();
        this.countMessages(true);
        this.loadingFile && (this.loadingFile = false);
      },
      (err) => console.log('error utils.datatoBlob(image, type)', err)
    );
  }

  buildImgMessage(message: Message, data: any) {
    message = this.formatMessageWithColor(message);
    let dataObj = null;
    if (this.enableDDBBStorage) {
      message.doc = data.includes('%%')? data : this.completeFile;
      dataObj = data.split('%%');
      message.id = parseInt(dataObj[1]);
    } else {
      message.doc = this.completeFile || message.doc;
    }
    message.fileName = (dataObj && dataObj[0])?? data;
    message.type = 'image/' + (message.fileName || '').split('.')[1];
    this.enableDDBBStorage && this.getChatFile(message);
    !this.enableDDBBStorage && this.parseImg(message);
  }

  buildPDFMessage(message: Message, data: any) {
    message = this.formatMessageWithColor(message);
    let dataObj = null;
    if (this.enableDDBBStorage) {
      message.doc = data.includes('%%')? data : this.completeFile;
      dataObj = data.split('%%');
      message.id = parseInt(dataObj[1]);
      message.fileName = dataObj[0];
    } else {
      message.doc = this.completeFile;
    }
    message.fileName = (dataObj && dataObj[0])?? data;
    message.type = 'application/' + (message.fileName || '').split('.')[1];
    this.utilsService.datatoBlob$(message.doc as string, message.type as string).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (blob: Blob) => {
        message.urlBlob = this.utilsService.blobToUrl(blob, message.fileName as string, message.type as string);
        this.chatMessages.push(message);
        this.changeDetectorRef.detectChanges();
        this.countMessages(true);
        this.loadingFile && (this.loadingFile = false);
        if (this.enableDDBBStorage && this.storedChatMessages?.length){
          this.setStoredMessasges();
        }
      },
      (err) => console.log('error utils.datatoBlob(pdf, type)', err)
    );
  }

  buildTextMessage(message: Message, data: any) {
    message.text = data;
    message.type = 'text';
    message = this.formatMessageWithColor(message);
    this.chatMessages.push(message);
    this.changeDetectorRef.detectChanges();
    this.countMessages(true);
    this.loadingFile && (this.loadingFile = false);
    if (this.enableDDBBStorage && this.storedChatMessages?.length){
      this.setStoredMessasges();
    }
  }

  getMessageData(message: string): MessageRawData {
    const messages = message.split('::');
    return {
      name: messages[0],
      data: messages[1]
    };
  }

  getSmallChat() {
    this.selectionFile = false;
    this.toggleChat.emit();
  }

  loadSignal() {
    this.session?.on(this.signalEvents.EMPTY, (event: any) => {
      const type: string = event.type;
      const chatAllowedSignals = Object.keys(this.getMessageMap);

      if (type === this.signalEvents.FILE) {
        this.completeFile += this.getMessageData(event.data).data;
      } else if (chatAllowedSignals.some(sign => sign === type)) {
        this.buildMessage(event);
      }
    });
  }

  onSubmit(e?: any) {
    e.preventDefault();
    if (!this.formChat) return;
    if (this.formChat.controls['textChat'].valid) {
      this.sendMessage(this.formChat.controls['textChat'].value, VIDEOCONFERENCE_CONSTANTS.CHAT.MESSAGE_TYPES.MSG);
      this.enableDDBBStorage && this.formChat.controls['textChat'].value && this.postStoreChatMessages({
        message: this.formChat.controls['textChat'].value,
        name: this.name
      });
    }
  }


  preventNewLine(event: Event) {
    event.preventDefault();
  }

  sendMessage(message: string, type: string, to?: any) {
    let signal = {};
    signal = {
      retryAfterReconnect: false, // trying no send messages after disconnetion
      type,
      data: this.name + '::' + message,
      ...(to && { to: to })
    };
    this.session?.signal(
      signal,
      (error) => {
        if (error) {
          console.log('signal error (' + error.name + '): ' + error.message);
        } else {
          if(this.formChat){
            this.formChat.controls['textChat'].setValue('');
            this.formChat.controls['file'].setValue('');
          }
        }
      }
    );
  }
  selectFile(event: any) {
    this.selectionFile = true; // By the moment, feature only works on Windows & Android
    this.changeDetectorRef.detectChanges();
    this.stateHandlerSvc.get('focusState').pipe(filter((val) =>  typeof val === 'boolean'))
        .pipe(distinctUntilChanged(), takeUntil(this.ngUnsubscribe)).subscribe(state => {
          console.log('chatComponent selectFile subscribe ('+this.utilsService.getTodayWithHour()+') focusState:', state);
          state && (this.selectionFile = false);
          this.changeDetectorRef.detectChanges();
        }
    );
  }

  addFiles($event: any): void {
    if($event.target.files.length === 0) {
      this.selectionFile = false;
      this.loadingFile = false;
      this.changeDetectorRef.detectChanges();
      return;
    }
    this.sendFile($event.target);
  }

  sendFile(file: any, storedFile?: boolean) {
    this.showAlertSizeFile = false;
    this.showAlertTypeFile = false;
    this.loadingFile = true;
    this.selectionFile = false;
    this.changeDetectorRef.detectChanges();
    this.utilsService.readFile(file).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((fileData: FileData) => {
        this.selectionFile = false;
        if (!this.enableDDBBStorage) {
          fileData.chunks.forEach((chunk) => {
            this.sendMessage(chunk, VIDEOCONFERENCE_CONSTANTS.CHAT.MESSAGE_TYPES.FILE);
          });
          this.sendFileByType(fileData);
        } else {
          !storedFile && this.enableDDBBStorage && this.postStoreChatMessages({
            fileType: fileData.type,
            file: fileData.result,
            fileName: fileData.name,
            name: this.name
          }, fileData);
        }
        this.changeDetectorRef.detectChanges();
      }, (err: FileError) => {
        this.showAlertTypeFile = err === VIDEOCONFERENCE_CONSTANTS.CHAT.ERROR_FILE_TYPE;
        this.showAlertSizeFile = err === VIDEOCONFERENCE_CONSTANTS.CHAT.ERROR_FILE_SIZE;
        this.loadingFile = false;
        this.changeDetectorRef.detectChanges();
      });
  }

  sendFileByType(fileData: FileData, fileId?: number) {
    switch (fileData.type) {
      case 'application/pdf':
        this.sendMessage((fileId? `${fileData.name}%%${fileId}`: fileData.name), VIDEOCONFERENCE_CONSTANTS.CHAT.MESSAGE_TYPES.FILE_PDF_END);
        break;
      case 'image/jpg':
      case 'image/jpeg':
      case 'image/png':
        this.sendMessage((fileId? `${fileData.name}%%${fileId}`: fileData.name), VIDEOCONFERENCE_CONSTANTS.CHAT.MESSAGE_TYPES.FILE_IMAGE_END);
        break;
      default:
        break;
    }
  }
  postStoreChatMessages(storeDataMessage: IPostStoredChatMessageRequest, fileData?: FileData){
    const attendantId = this.activatedRoute.snapshot.queryParams[VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT];
    storeDataMessage.attendantId = attendantId;
    this.apiChatMessagesService.postMessage(storeDataMessage).pipe(take(1)).subscribe(
      (resp: IPostStoredChatMessageResponseItem) => {
        if (fileData?.type) {
          this.sendFileByType(fileData, resp.dateMessage);
        }
      }
    );
  }
  openFile(message: Message) {
    //Mensage guardado en BBDD (tiene id)
    if (this.enableDDBBStorage && message.id) {
      let type = null;
      if ((message.type || '').includes('image')) {
        type = 'image/' + (message.fileName || '').split('.')[1];
      } else {
        type = 'application/' + (message.fileName || '').split('.')[1];
      }
      this.getChatFile(message, true);
    } else {
      if (!this.isIOsMobilityDevice) {
        this.videoconferenceMainModalService.setFilesOperationsData(message);
        this.videoconferenceMainModalService.openModal();
      } else {
        this.utilsService.openFile(message.doc as string, message.fileName as string, message.type as string);
      }
    }
    this.changeDetectorRef.detectChanges();
  }

  toggleAlertSizeFile() {
    this.showAlertSizeFile = !this.showAlertSizeFile;
  }

  toggleAlertTypeFile() {
    this.showAlertTypeFile = !this.showAlertTypeFile;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private validChatMessage(control: FormControl) {
    const valueWithNoLines = control.value.replace('\n', '').trim();
    let error;
    if (!valueWithNoLines.length) {
      error = { noMessage: !valueWithNoLines.length };
    }
    return error;
  }
}
